export const message = {
  NOT_APPID: '请填写 appId ，可从控制台-我的应用-语音评测（流式版）页面获取。',
  NOT_URL: '请传入 IseWebSocket 连接时的 url',
  NOT_SUPPORT_WEB_SOCKET: '浏览器不支持 WebSocket',
  NOT_SUPPORT_WEB_AUTIO: '浏览器不支持 webAudioApi 相关接口'
}
